import { useRecoilState } from "recoil";
import participantsState from "../../../atoms/participants";
import userDetailsState from "../../../atoms/userDetails";
import { UserDetail } from "../../../connector/type";
import "./HomeMembers.scoped.scss";
import Member from "./Member";

// UserDetail, roomOwnerId => Admin: 3, Member: 1(Order by grade), Guest: 0
const getUserOrder = (d: UserDetail | undefined) => (d == null)
  ? 0 
  : (
    d.level >= 28 
      ? 3 
      : (1 + (0.01 * d.level))
    );

function HomeMembers() {
  const [participants] = useRecoilState(participantsState);
  const [userDetails] = useRecoilState(userDetailsState);

  // Remove duplicates
  const users = participants.users.filter((v, i, a) => a.indexOf(v) === i);
  // Sort (Order by desc)
  users.sort((a, b) => getUserOrder(userDetails.get(b)) - getUserOrder(userDetails.get(a)));

  return (
    <div className="member-list">
      {participants.roomId === 'square' 
        ? users.map((id, index) => {
            const userDetail = userDetails.get(id);
            const level = userDetail?.level ?? 1;
            const nickname = userDetail?.nickname ?? id;
            return (
              <Member 
                key={index} 
                level={level} 
                nickname={nickname} 
              />
            )
          })
        : null
      }
    </div>
  );
}

export default HomeMembers;